module.exports = __webpack_public_path__ + "7374c748cb1b5bbf582aa7d3892f4797.pdf";